// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"118a9788","415":"d907afd7","453":"51ecb064","534":"4e71ff03","659":"73822790","687":"c84dec34","843":"aa3a9ea1","894":"f65e1174","906":"711fdf9e"}[chunkId] + ".chunk.js";
};